import { useRef } from 'react';
import isEqual from 'lodash/isEqual';

// Returns a stable reference to `value` that only updates when its deep
// content changes. Useful as a memoization key for objects/arrays whose
// upstream identity changes on every render but whose content rarely does
// — e.g., chart data passed from a parent that rebuilds the array each
// render. Avoids the JSON.stringify-as-dep pattern, which is O(n) on every
// render and silently misbehaves for non-serializable values.
export function useDeepCompareMemoize(value) {
  const ref = useRef();
  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}

export default useDeepCompareMemoize;
